/* globals getUploadUrl, existsAttachmentUrl, expenseId, linkAttachmentUrl, ACCEPTED_ATTACHMENT_FILE_TYPES */
import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import UploadExpenseAttachment from './UploadExpenseAttachment';

export function mountExpenseAttachmentUploader(rootEl, props) {
    ReactDOM.render(
        <App>
            <UploadExpenseAttachment {...props} />
        </App>,
        rootEl,
    );
}

if (document.getElementById('UploadExpenseAttachment')) {
    mountExpenseAttachmentUploader(document.getElementById('UploadExpenseAttachment'), {
        getUploadUrl,
        existsAttachmentUrl,
        expenseId,
        linkAttachmentUrl,
        acceptedFileTypes: ACCEPTED_ATTACHMENT_FILE_TYPES,
    });
}

// The side panel's forms carry their uploader settings on the mount element itself.
document.addEventListener('side-panel:mounted', (event) => {
    event.detail.form.querySelectorAll('[data-expense-attachment-uploader]').forEach((rootEl) => {
        mountExpenseAttachmentUploader(rootEl, {
            getUploadUrl: rootEl.dataset.getUploadUrl,
            existsAttachmentUrl: rootEl.dataset.existsUrl,
            expenseId: rootEl.dataset.expenseId ? Number(rootEl.dataset.expenseId) : 0,
            linkAttachmentUrl: rootEl.dataset.linkUrl,
            acceptedFileTypes: rootEl.dataset.acceptedTypes,
            // A file attached to a new line only rides on the form, so it counts as an edit.
            onUploaded: () => rootEl.dispatchEvent(new Event('change', { bubbles: true })),
        });
    });
});

document.addEventListener('side-panel:unmount', (event) => {
    event.detail.form.querySelectorAll('[data-expense-attachment-uploader]').forEach((rootEl) => {
        ReactDOM.unmountComponentAtNode(rootEl);
    });
});
